import { useEffect, useState } from 'react';

interface Timeout {
  set: (callback: () => void, milliseconds: number) => void;
  clear: () => void;
}

export const useSetTimeout = (): Timeout => {
  const [theTimeout, setTheTimeout] = useState<NodeJS.Timeout>();

  const set = (callback: () => void, milliseconds: number) =>
    setTheTimeout(setTimeout(callback, milliseconds));

  const clear = () => {
    if (theTimeout) {
      clearTimeout(theTimeout);
      setTheTimeout(undefined);
    }
  };

  // unmount hook - needed to clear timeout
  useEffect(() => () => theTimeout && clearTimeout(theTimeout), [theTimeout]);

  return { set, clear };
};
